import * as DialogPrimitive from '@radix-ui/react-dialog'
import { Cross2Icon as CrossIcon } from '@radix-ui/react-icons'
import { ComponentProps, VariantProps } from 'style'

import Box from 'components/atomic/atoms/box'
import { IconStyled } from 'components/atomic/atoms/icon'
import {
  StyledClose,
  StyledContent,
  StyledDescription,
  StyledOverlay,
  StyledTitle,
} from 'components/atomic/molecules/modal/modal.styled'

import { FCC } from 'types/react'

export const Root = DialogPrimitive.Root
export const Trigger = DialogPrimitive.Trigger
export const Title = StyledTitle
export const Description = StyledDescription
export const Close = DialogPrimitive.DialogClose

type ContentVariants = VariantProps<typeof StyledContent>
type ContentBaseProps = ComponentProps<typeof StyledContent>
type ContentCustomProps = {
  withCloseButton?: boolean
}
type ContentProps = ContentBaseProps & ContentVariants & ContentCustomProps

export const Content: FCC<ContentProps> = ({
  children,
  withCloseButton = true,
  ...props
}) => {
  return (
    <DialogPrimitive.Portal>
      <StyledOverlay />
      <StyledContent {...props}>
        <Box>{children}</Box>
        {withCloseButton && (
          <StyledClose>
            <IconStyled as={CrossIcon} size="xl" />
          </StyledClose>
        )}
      </StyledContent>
    </DialogPrimitive.Portal>
  )
}
